import { Activity, Users, Target, TrendingUp } from 'lucide-react';

interface DashboardMetrics {
  total_surveys: number;
  active_surveys: number;
  total_responses: number;
  avg_completion_rate: number;
}

interface StatsOverviewProps {
  metrics: DashboardMetrics | null;
}

export function StatsOverview({ metrics }: StatsOverviewProps) {
  // Ensure completion rate is capped at 100%
  const safeCompletionRate = metrics?.avg_completion_rate 
    ? Math.min(metrics.avg_completion_rate, 100) 
    : 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-3 min-w-0">
              <div className="p-2 bg-blue-50 dark:bg-blue-900/50 rounded-lg flex-shrink-0">
                <Activity className="h-5 w-5 text-blue-600 dark:text-blue-400" />
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-gray-900 dark:text-white truncate">
                  Active Surveys
                </h3>
                <p className="mt-1 text-2xl font-semibold text-gray-900 dark:text-white">
                  {metrics?.active_surveys || 0}
                </p>
              </div>
            </div>
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300">
              {metrics?.total_surveys || 0} total
            </span>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-3 min-w-0">
              <div className="p-2 bg-green-50 dark:bg-green-900/50 rounded-lg flex-shrink-0">
                <Users className="h-5 w-5 text-green-600 dark:text-green-400" />
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-gray-900 dark:text-white truncate">
                  Total Responses
                </h3>
                <p className="mt-1 text-2xl font-semibold text-gray-900 dark:text-white">
                  {metrics?.total_responses || 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-3 min-w-0">
              <div className="p-2 bg-purple-50 dark:bg-purple-900/50 rounded-lg flex-shrink-0">
                <Target className="h-5 w-5 text-purple-600 dark:text-purple-400" />
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-gray-900 dark:text-white truncate">
                  Avg. Completion Rate
                </h3>
                <p className="mt-1 text-2xl font-semibold text-gray-900 dark:text-white">
                  {safeCompletionRate}%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <div className="flex items-start space-x-3 min-w-0">
              <div className="p-2 bg-orange-50 dark:bg-orange-900/50 rounded-lg flex-shrink-0">
                <TrendingUp className="h-5 w-5 text-orange-600 dark:text-orange-400" />
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-gray-900 dark:text-white truncate">
                  Daily Avg. Responses
                </h3>
                <p className="mt-1 text-2xl font-semibold text-gray-900 dark:text-white">
                  {metrics?.total_responses ? Math.round(metrics.total_responses / 30) : 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}